// src/services/api.js

import axios from 'axios';

// Base API URL
export const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Media base (removes /api)
export const MEDIA_BASE_URL = API_URL.replace(/\/api\/?$/, '');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Add auth token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (!error.config.url.includes('/auth/me')) {
        localStorage.removeItem('token');
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
